interface SpeedbumpOptions {
    header?: string;
    message?: string;
    button_cancel?: string;
    button_ok?: string;
    id?: string;
    confirm_function?: (() => void) | null;
    cancel_function?: (() => void) | null;
    ok_link?: string;
    window_target?: string;
    clickedElement?: HTMLAnchorElement;
}

interface SpeedbumpSettings {
    header: string;
    message: string;
    button_cancel: string;
    button_ok: string;
    id: string;
    confirm_function: (() => void) | null;
    cancel_function: (() => void) | null;
    ok_link: string;
    window_target: string;
    clickedElement: HTMLAnchorElement;
}

// // Note: vExtend, vShow, and vHide are assumed to be utility functions defined elsewhere
// declare function vExtend<T>(defaults: T, options?: Partial<T>): T;
// declare function vShow(element: HTMLElement): void;
// declare function vHide(element: HTMLElement): void;

function speedbump(options?: SpeedbumpOptions): boolean {
    // Options
    const settings: SpeedbumpSettings = vExtend({
        // These are the defaults
        header: "You are continuing to another website.",
        message: "You will be linking to another website not owned or operated by us. We do not control these sites and do not guarantee the accuracy, completeness, efficiency or timeliness of the information contained therein. We encourage you to review their privacy and security policies which may differ from ours.",
        button_cancel: "Return to Our Site",
        button_ok: "OK",
        id: "default",
        confirm_function: null,
        cancel_function: null,
        ok_link: "",
        window_target: "_self",
        clickedElement: null as unknown as HTMLAnchorElement
    }, options || {});

    // If no link is provided to override, source it from the clicked element
    if (settings.ok_link === "") {
        settings.ok_link = settings.clickedElement.getAttribute("href") || "";
    }

    // If the clicked element has no target, set as self, otherwise, set as the clicked element's target
    if (settings.clickedElement.hasAttribute("target") && settings.clickedElement.getAttribute("target") !== "") {
        settings.window_target = settings.clickedElement.getAttribute("target") || "_self";
    }

    // If an ID exists, assign it
    if (settings.id !== "") {
        settings.id = "_" + settings.id;
    }

    // Check to see if the markup for this speedbump has already been appended and if not append it
    if (document.querySelectorAll(".js-speedbump_pop" + settings.id).length === 0) {
        const bodyElement = document.querySelector("body");
        if (!bodyElement) return false;

        const speedbumpElement = document.createElement('section');
        speedbumpElement.className = "js-speedbump_pop" + settings.id + " speedbump_back";
        speedbumpElement.style.display = "none";
        speedbumpElement.setAttribute('aria-label', 'Speedbump - Please review');
        speedbumpElement.innerHTML = "<div class='speedbump_pop_inner'><div class='speedbump_pop_content tablock'></div></div>";
        bodyElement.appendChild(speedbumpElement);
    }

    // Assign a variable to refer to the speedbump we just added to the DOM
    const currentSpeedbump = document.querySelector(".js-speedbump_pop" + settings.id) as HTMLElement;
    if (!currentSpeedbump) return false;

    // Build the speedbump inner HTML based on the values passed to settings and then set it
    let valid = true;
    let spb = "";
    if (settings.header !== "") {
        spb += "<h2 class='speedbump_pop_header'>" + settings.header + "</h2>";
    }
    spb += "<div class='speedbump_pop_message'>" + settings.message + "</div>" +
        "<div class='speedbump_pop_buttons'>" +
        "<a href='" + settings.clickedElement.getAttribute("href") + "' class='cta-btn-orange js-speedbump_btn_ok" + settings.id + " speedbump_pop_btn speedbump_pop_btn_ok' target='" + settings.window_target + "' data-no-speedbump><span class='text'>" + settings.button_ok + "</span></a>" +
        "<button type='button' class='js-speedbump_btn_cancel" + settings.id + " cta-btn-white speedbump_pop_btn speedbump_pop_btn_cancel'><span class='text'>" + settings.button_cancel + "</span></button>" +
        "</div>";

    const contentElement = currentSpeedbump.querySelector(".speedbump_pop_content");
    if (contentElement) {
        contentElement.innerHTML = spb;
    }

    // Now that the markup is complete, set reference variables to the current speedbump for the rest of the code
    const currentSpeedbumpInner = currentSpeedbump.querySelector(".speedbump_pop_inner") as HTMLElement;
    const currentOKButton = currentSpeedbump.querySelector(".js-speedbump_btn_ok" + settings.id) as HTMLAnchorElement;
    const currentCancelButton = currentSpeedbump.querySelector(".js-speedbump_btn_cancel" + settings.id) as HTMLButtonElement;

    if (!currentOKButton || !currentCancelButton) return false;

    // ESC key behavior
    if (!currentSpeedbump.classList.contains("esc-bound")) {
        currentSpeedbump.addEventListener("keyup", function(event: KeyboardEvent) {
            if (event.keyCode === 27 && currentSpeedbump.style.display !== "none") {
                setTimeout(function() {
                    currentSpeedbump.classList.remove("sb-active");
                }, 100);
                setTimeout(function() {
                    vHide(currentSpeedbump);
                }, 600);
                currentSpeedbump.removeAttribute("role");
                valid = false;
                if (settings.cancel_function !== null) {
                    settings.cancel_function();
                }
                settings.clickedElement.focus();
            }
        });
        currentSpeedbump.classList.add("esc-bound");
    }

    // OK button click event
    if (!currentOKButton.classList.contains("bound")) {
        currentOKButton.addEventListener("click", function(event: MouseEvent) {
            setTimeout(function() {
                currentSpeedbump.classList.remove("sb-active");
            }, 100);
            setTimeout(function() {
                vHide(currentSpeedbump);
            }, 600);
            currentSpeedbump.removeAttribute("role");
            if (settings.confirm_function !== null) {
                settings.confirm_function();
            }
        });
        currentOKButton.classList.add("bound");
    }

    // Cancel button click event
    if (!currentCancelButton.classList.contains("bound")) {
        currentCancelButton.addEventListener("click", function(event: MouseEvent) {
            setTimeout(function() {
                currentSpeedbump.classList.remove("sb-active");
            }, 100);
            setTimeout(function() {
                vHide(currentSpeedbump);
            }, 600);
            currentSpeedbump.removeAttribute("role");
            valid = false;
            if (settings.cancel_function !== null) {
                settings.cancel_function();
            }
            settings.clickedElement.focus();
        });
        currentCancelButton.classList.add("bound");
    }

    // Move any tracking from link to confirm ok button
    currentOKButton.removeAttribute("data-track");
    currentOKButton.removeAttribute("data-event");
    currentOKButton.removeAttribute("data-track-category");
    currentOKButton.removeAttribute("data-track-action");
    currentOKButton.removeAttribute("data-track-value");

    if (settings.clickedElement.hasAttribute("data-track") && settings.clickedElement.getAttribute("data-track") !== "") {
        currentOKButton.setAttribute("data-track", settings.clickedElement.getAttribute("data-track") || "");
    }
    if (settings.clickedElement.hasAttribute("data-event") && settings.clickedElement.getAttribute("data-event") !== "") {
        currentOKButton.setAttribute("data-event", settings.clickedElement.getAttribute("data-event") || "");
    }
    if (settings.clickedElement.hasAttribute("data-track-category") && settings.clickedElement.getAttribute("data-track-category") !== "") {
        currentOKButton.setAttribute("data-track-category", settings.clickedElement.getAttribute("data-track-category") || "");
    }
    if (settings.clickedElement.hasAttribute("data-track-action") && settings.clickedElement.getAttribute("data-track-action") !== "") {
        currentOKButton.setAttribute("data-track-action", settings.clickedElement.getAttribute("data-track-action") || "");
    }
    if (settings.clickedElement.hasAttribute("data-track-value") && settings.clickedElement.getAttribute("data-track-value") !== "") {
        currentOKButton.setAttribute("data-track-value", settings.clickedElement.getAttribute("data-track-value") || "");
    }

    // The code to display the speedbump
    vShow(currentSpeedbump);
    currentSpeedbump.setAttribute("role", "alert");
    currentSpeedbump.setAttribute("data-url", settings.ok_link);
    setTimeout(function() {
        currentSpeedbump.classList.add("sb-active");
    }, 100);
    setTimeout(function() {
        currentOKButton.focus();
    }, 200);

    return false;
}